import { Schema, SchemaType } from "../../../core/render/logic/Markdoc/index";

export const article: Schema = {
	render: "article",
	type: SchemaType.block,
};
